import { ChangeDetectionStrategy, Component } from "@angular/core";
import { LookerRiskDashboardType } from "../../looker-risk-dashboard-type.enum";
import { HideFilters } from "../../models/analytics-hide-filters.enum";

@Component({
  selector: "app-analytics-risk-overview-dw",
  templateUrl: "./analytics-risk-overview-dw.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AnalyticsRiskOverviewDwComponent {
  filters: string[] = ["Projects"];
  dashboardType = LookerRiskDashboardType.OVERVIEW_DW;
  hideFilters: string[] = [HideFilters.PROJECT_ID, HideFilters.USER_ID2, HideFilters.ORG_ID];
}

